import { useTranslations } from "use-intl";

import { CompactDiscIcon, VinylIcon } from "@/components/appIcons";
import { WhatsAppIcon } from "@/components/icons/whatsapp-icon";

const DEMO_POSTS = [
  { group: "VinylGroup", message: "VinylMessage", icon: VinylIcon },
  { group: "CdGroup", message: "CdMessage", icon: CompactDiscIcon },
] as const;

export function WhatsAppCommunityDemo() {
  const t = useTranslations("whatsapp");
  return (
    <div className="relative mx-auto w-full max-w-md" aria-label={t("demoTitle")}>
      <div
        className="absolute -inset-5 -z-10 rotate-2 rounded-[2rem] bg-[#e55b2b]/15"
        aria-hidden="true"
      />
      <div className="overflow-hidden rounded-[1.75rem] bg-[#202621] shadow-[0_22px_65px_rgba(0,0,0,.34)]">
        <div className="flex items-center gap-3 border-b border-white/10 bg-[#182019] px-5 py-4">
          <span className="flex size-10 items-center justify-center rounded-xl bg-[#25D366] text-[#07170d]">
            <WhatsAppIcon className="size-5" />
          </span>
          <p className="font-black">{t("demoTitle")}</p>
        </div>
        <div className="space-y-3 p-4 sm:p-5">
          {DEMO_POSTS.map((post, index) => {
            const PostIcon = post.icon;
            return (
              <div className="rounded-xl bg-[#2a302b] p-4" key={post.group}>
                <div className="flex items-center gap-2 text-xs font-black text-[#8fe7ad]">
                  <PostIcon className="text-base" decorative />
                  {t(`demo${post.group}`)}
                  <span className="ml-auto font-medium tabular-nums text-[#858b86]">
                    {10 + index}:2{index}
                  </span>
                </div>
                <p className="mt-2 text-sm leading-6 text-[#dedbd3]">{t(`demo${post.message}`)}</p>
              </div>
            );
          })}
        </div>
        <p className="border-t border-white/10 px-5 py-4 text-xs leading-5 text-[#999f99]">
          {t("demoDescription")}
        </p>
      </div>
    </div>
  );
}
